<script>
import LoginComponent from "@/components/Auth/Login";
import SignupComponent from "@/components/Auth/Signup";
import anymatch from "anymatch";
import firebase from "firebase/compat/app";
import _ from "lodash";
import CircleInfoSolid from "./fontawesome/circle-info-solid.vue";
import { mdiPaletteAdvanced } from "@mdi/js";

export default {
  data: () => ({
    dates: [],
    date: new Date().toJSON(),
    bookDialog: false,
    deliveryFee: 0,
    continueBookingAfterLogin: false,
    showLoadingForBookItem: false,
    difDays: 0,
    endDate: new Date().toJSON(),
    fullDay: 0,
    lenderReceivable: 0,
    loginDialog: false,
    subTotal: 0,
    signupDialog: false,
    startDateText: "",
    dailyEffectiveRate: 0,
    endDateText: "",
    startDate: "",
    endTS: new Date(),
    startTS: new Date(),
    endDate: "",
    dateRange: "",
    successDialog: false,
    loadedBookings: [],
    discountType: "",
    comment: "",
    discount: 0,
    suburb: "",
    showPicker: true,
    serviceFee: 0,
    depositHandlingFee: 0,
    total: 0,
    bookingDates: ["2022-07-04", "2022-06-30"],
    rentalFee: 0,
    el: [],
    time: null,
    // dynamicRate: 0,
    deliverySwitch: "",
    bookingAlert: false,
    menu: false,
    modal: false,
    menu1: false,
    bp: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    totalServiceFee: 0,
    allowedDates: [],
    bookingplaced: false,
  }),
  components: {
    LoginComponent,
    SignupComponent,
    CircleInfoSolid,
  },

  async mounted() {
    await this.$store.dispatch("loadBookings");
    //  await this.getAllowedDates();
    // this.getDates()
  },

  methods: {
    onClose() {
      this.bp = false;
    },
    getDates(start, end) {
      for (
        var arr = [], dt = new Date(start);
        dt <= new Date(end);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(new Date(dt));
      }
      return arr;
    },

    async getAllowedDates() {
      this.showPicker = false;
      let bookings = this.getBookings();

      this.bookingDates = [];
      for (var i in bookings) {
        // console.log('end dateV1: ', bookings[i].endDate);
        let endDay = new Date(bookings[i].endDate);
        let startDay = new Date(bookings[i].startDate);
        // console.log(startDay, endDay)
        let range = this.getDates(startDay, endDay);
        for (var x in range) {
          await this.bookingDates.push(range[x].toISOString().substring(0, 10));
        }
        //  await this.bookingDates.push(endDay.toISOString().substring(0, 10))

        //  await this.bookingDates.push(startDay.toISOString().substring(0, 10))
      }
      // console.log(this.bookingDates);
      this.showPicker = true;
    },

    disabledDates(val) {
      let bookings = this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.itemID === this.item.id &&
          (booking.status === "awaiting-images" ||
            booking.status === "finalised" ||
            booking.status === "active")
        ); //add booking status
      });

      let bookedDates = [];
      for (var i in bookings) {
        // console.log('end dateV1: ', bookings[i].endDate);
        let endDay = new Date(bookings[i].endDate);
        endDay.setDate(endDay.getDate() + parseInt(1));
        let startDay = new Date(bookings[i].startDate);
        startDay.setDate(startDay.getDate() + parseInt(1));
        // console.log(endDay.toISOString());
        // console.log(startDay, endDay)
        let range = this.getDates(startDay, endDay);
        for (var x in range) {
          bookedDates.push(range[x].toISOString().substring(0, 10));
        }
        // bookedDates.push(endDay.toISOString().substring(0, 10));

        // bookedDates.push(startDay.toISOString().substring(0, 10));
      }

      // console.log(bookedDates);
      return bookedDates.indexOf(val) === -1;
    },

    getBookings() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return booking.itemID === this.item.id; //add booking status
      });
    },

    dashboard() {
      this.$router.push("/dashboard");
    },
    items() {
      this.$router.push("/search");
    },
    clearSelection() {
      this.dates = [];
    },
    async submitBooking() {
      if (!this.userIsAuthenticated()) {
        this.signupDialog = true;
        this.continueBookingAfterLogin = true;
      } else {
        if (this.bookingplaced) {
          return;
        }
        this.bookingplaced = true;
        this.showLoadingForBookItem = true;
        this.bookDialog = false;
        //write a method that submits the dates as well as suburb and comment to firestore collection bookings
        const bookingData = {
          dateRange: this.dateRange,
          startDateText: this.startDateText,
          endDateText: this.endDateText,
          endDateTS: this.endTS,
          startDateTS: this.startTS,
          suburb: this.suburb,
          comment: this.comment,
          deliveryFee: this.deliveryFee,
          rentalFee: this.rentalFee,
          serviceFee: this.serviceFee,
          totalServiceFee: this.totalServiceFee,
          grossTotal: this.grossTotal,
          status: "pending",
          lenderReceivable: this.lenderReceivable,
          total: this.total,
          deposit: this.item.deposit,
          itemID: this.item.id,
          images: this.item.images,
          itemName: this.item.itemName,
          lenderID: this.item.userID,
          lenderAvatar: this.item.userAvatar,
          lenderName: this.item.created_by,
          dailyFee: this.item.dailyFee,
          weeklyFee: this.weeklyFee,
          delivery: this.deliverySwitch,
          subTotal: this.subTotal,
          discount: this.discount,
          dailyEffectiveRate: this.dailyEffectiveRate,

          // lenderAvatar: this.item.userAvatar,
          //test
        };
        this.$store.dispatch("createBooking", bookingData).then(() => {
          this.showLoadingForBookItem = false;
          this.signupDialog = false;
          this.loginDialog = false;
          this.successDialog = true;
          this.bookingAlert = true;
        });
      }
    },

    generateKey() {
      // console.log('generate step 0');
      this.$store.dispatch("generateKey");
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    // userIsLogged() {
    //   if (!this.userIsAuthenticated) {
    //     return false;
    //   } else if (this.userIsAuthenticated) {
    //     return true;
    //   }
    // },

    userIsNotAuthenticated() {
      return (
        this.$store.getters.user == null &&
        this.$store.getters.user == undefined
      );
    },
  },

  // mounted() {
  //   console.log(this.delivery);
  //   console.log("availabilty:", this.item.availabilty);
  // },

  computed: {
    bookingDates() {
      let bookings = this.getBookings();

      let bookedDates = [];
      for (var i in bookings) {
        console.log("end dateV1: ", bookings[i].endDate);
        let endDay = new Date(bookings[i].endDate);
        let startDay = new Date(bookings[i].startDate);
        // console.log(startDay, endDay)
        let range = this.getDates(startDay, endDay);
        for (var x in range) {
          bookedDates.push(range[x].toISOString().substring(0, 10));
        }
        //  await this.bookingDates.push(endDay.toISOString().substring(0, 10))

        //  await this.bookingDates.push(startDay.toISOString().substring(0, 10))
      }
      return bookedDates;
    },
    user() {
      return this.$store.getters.user;
    },
    firstName() {
      return this.$store.getters.user.firstName;
    },
    progress() {
      return Math.min(100, this.itemDescription.length * 1.6);
    },
    color() {
      return ["red", "orange", "green"][Math.floor(this.progress / 40)];
    },
  },

  props: ["item"],

  watch: {
    user(value) {
      console.log("watch value:", value);
      // if (value !== null && value !== undefined) {
      //   if (this.shouldRedirect) {
      //     this.$router.push('/dashboard');
      //     this.$emit('loggedIn');
      //   } else if (this.addItem) {
      //     this.welcomeDialog = true;
      //     this.$emit('loggedIn');
      //   } else {
      //     this.$emit('loggedIn');
      //   }
      // }
      if (value.firstName != null && this.continueBookingAfterLogin) {
        console.log("is this gonna run????");
        this.submitBooking();
      }
    },

    deliverySwitch(delivery) {
      if (delivery == true) {
        this.deliveryFee = this.item.deliveryFee;
        if (!_.isEmpty(this.item.deposit)) {
          console.log("deposit", this.item.deposit);
          this.depositHandlingFee = Number(this.item.deposit * 0.0125);
          console.log(this.depositHandlingFee);
        }
        this.serviceFee = (
          (Number(this.rentalFee) + Number(this.deliveryFee)) *
          0.1
        ).toFixed(0);
        console.log("serviceFee", this.serviceFee);
        this.totalServiceFee = (
          Number(this.serviceFee) + Number(this.depositHandlingFee)
        ).toFixed(0);
        console.log("total serviceFee", this.totalServiceFee);
      } else {
        this.deliveryFee = 0;
        this.serviceFee = (this.rentalFee * 0.1).toFixed(0);
        this.totalServiceFee =
          Number(this.serviceFee) + Number(this.depositHandlingFee);
      }
      // if (this.total != 0) {
      //   this.rentalFee = (
      //     Number(this.grossTotal) + Number(this.deliveryFee)
      //   ).toFixed(0);
      // }

      this.subTotal = (
        Number(this.rentalFee) +
        Number(this.deliveryFee) +
        Number(this.totalServiceFee)
      ).toFixed(0);

      this.total = (
        Number(this.rentalFee) +
        Number(this.deliveryFee) +
        Number(this.item.deposit) +
        Number(this.totalServiceFee)
      ).toFixed(0);
      this.total = Math.round(this.total);
      this.lenderReceivable = (
        Number(this.rentalFee) +
        Number(this.deliveryFee) -
        Number(this.totalServiceFee)
      ).toFixed(0);
    },

    dates(newDates) {
      if (newDates.length >= 1) {
        //set the startDate to be the earliest date in the array
        var startDate = new Date(newDates[0]);
        if (newDates.length === 1) {
          var endDate = new Date(newDates[0]);
        } else {
          var endDate = new Date(newDates[1]);
        }
        //change startDate to be the earliest date in the newDates array
        if (startDate > endDate) {
          startDate = new Date(newDates[1]);
          endDate = new Date(newDates[0]);
        }
        // const startDate = new Date(newDates[0]);
        // const endDate = new Date(newDates[1]);
        const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        this.difDays = diffDays;

        if (diffDays == 0) {
          this.fullDay = true;
          this.dateRange = 1;
        } else {
          this.dateRange = diffDays;
          this.fullDay = false;
        }
        this.startDateText = startDate.toLocaleDateString("en-UK", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
        this.endTS = endDate;
        this.startTS = startDate;
        this.endDateText = endDate.toLocaleDateString("en-UK", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
      } else if (newDates.length === 0 || newDates.length === 1) {
        this.dateRange = "";
        this.startDateText = "";
        this.endDateText = "";
      }

      //Price calculations

      if (this.dateRange < 7 && this.item.dailyFee != "") {
        console.log("day");
        this.rentalFee = this.item.dailyFee * this.dateRange;
        this.rentalFee = this.rentalFee.toFixed(0);
        this.dailyEffectiveRate = this.rentalFee;
        this.discount = 0;
      } else if (
        this.dateRange >= 7 &&
        this.dateRange < 28 &&
        this.item.weeklyFee != "" &&
        this.item.monthlyFee != "0" &&
        this.monthlyFee != 0 &&
        this.item.weeklyFee != null &&
        this.item.weeklyFee != undefined
      ) {
        console.log("week");
        this.effectiveWeeklyRate = this.item.weeklyFee / 7;
        this.rentalFee = (this.effectiveWeeklyRate * this.dateRange).toFixed(2);

        this.dailyEffectiveRate = this.item.dailyFee * this.dateRange;
        this.dailyEffectiveRate = this.dailyEffectiveRate.toFixed(2);

        this.rentalFee = Math.round(this.rentalFee);

        this.discountType = "weekly";

        this.discount = Math.round(
          Number(this.dailyEffectiveRate) - Number(this.rentalFee)
        );
      } else if (
        this.dateRange >= 28 &&
        this.item.monthlyFee != "" &&
        this.item.monthlyFee != "0" &&
        this.monthlyFee != 0 &&
        this.item.monthlyFee != null &&
        this.item.monthlyFee != undefined
      ) {
        console.log("month");
        this.effectiveMonthlyRate = this.item.monthlyFee / 28;
        this.rentalFee = (this.effectiveMonthlyRate * this.dateRange).toFixed(
          2
        );

        this.rentalFee = Math.round(this.rentalFee);

        this.dailyEffectiveRate = this.item.dailyFee * this.dateRange;
        this.dailyEffectiveRate = this.dailyEffectiveRate.toFixed(2);

        this.discountType = "monthly";

        this.discount = Math.round(
          Number(this.dailyEffectiveRate) - Number(this.rentalFee)
        );
      } else {
        console.log("No week/month");
        this.rentalFee = this.item.dailyFee * this.dateRange;
        this.rentalFee = this.rentalFee.toFixed(0);
        this.dailyEffectiveRate = this.rentalFee;
        this.discount = 0;
      }

      if (!_.isEmpty(this.item.deposit)) {
        this.depositHandlingFee = (this.item.deposit * 0.0125).toFixed(0);
      } else {
        this.depositHandlingFee = 0;
      }

      console.log("deposit handling Fee", this.depositHandlingFee);

      this.serviceFee = (
        (Number(this.rentalFee) + Number(this.deliveryFee)) *
        0.1
      ).toFixed(0);
      this.totalServiceFee = (
        Number(this.serviceFee) + Number(this.depositHandlingFee)
      ).toFixed(0);

      console.log("total service Fee", this.totalServiceFee);

      this.subTotal = (
        Number(this.rentalFee) +
        Number(this.deliveryFee) +
        Number(this.totalServiceFee)
      ).toFixed(0);
      this.total = (
        Number(this.rentalFee) +
        Number(this.item.deposit) +
        Number(this.totalServiceFee)
      ).toFixed(2);
      this.lenderReceivable = (
        Number(this.rentalFee) - Number(this.totalServiceFee)
      ).toFixed(2);
    },
  },
};
</script>

<template>
  <div>
    <v-btn
      slot="activator"
      color="secondary lighten-1"
      width="190"
      height="40"
      rounded
      :disabled="this.item.availabilty === false"
      class="appbutton mx-1 mt-1 font-weight-bold"
      @click.prevent="bookDialog = true"
    >
      <span v-if="this.item.availabilty === false">Item Not available</span>
      <span v-else-if="this.item.availabilty === true"
        >Send Rental Request</span
      >
    </v-btn>

    <!-- <v-btn
      slot="activator"
      color="secondary lighten-1"
      width="190"
      height="40"
      rounded
      :disabled="this.item.availabilty === false"
      class="appbutton mx-1 mt-1 font-weight-bold"
      @click="generateKey"   >
      <span v-if="this.item.availabilty === false">Item Not available</span>
      <span v-else-if="this.item.availabilty === true">gen key</span>
    </v-btn> -->

    <v-dialog
      style="overflow-y: scroll; overflow-x: hidden; border-radius: 12px"
      v-model="bookDialog"
      :width="$vuetify.breakpoint.mdAndUp ? '90vw' : ''"
    >
      <v-card
        :class="$vuetify.breakpoint.mdAndUp ? 'pa-4' : 'pa-4'"
        style="border-radius: 12px"
        elevation="8"
      >
        <v-card-title
          :class="$vuetify.breakpoint.mdAndUp ? 'text-h4' : 'text-h6'"
        >
          <v-row
            ><span class="text-subtitle-1">{{ item.itemName }}</span>

            <v-spacer></v-spacer>
            <svg
              @click="bookDialog = false"
              style="cursor: pointer"
              height="30px"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="circle-xmark"
              class="section svg-inline--fa fa-circle-xmark"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <g class="fa-duotone-group">
                <path
                  class="fa-secondary"
                  fill="#F8955B"
                  d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
                ></path>
                <path
                  class="fa-primary"
                  fill="#B22AF0"
                  d="M289.9 255.1l47.03-47.03c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L256 222.1L208.1 175c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l47.03 47.03L175 303c-9.375 9.375-9.375 24.56 0 33.94c9.373 9.373 24.56 9.381 33.94 0L256 289.9l47.03 47.03c9.373 9.373 24.56 9.381 33.94 0c9.375-9.375 9.375-24.56 0-33.94L289.9 255.1z"
                ></path>
              </g></svg></v-row
        ></v-card-title>
        <v-row>
          <v-card-subtitle
            @click="$router.push('/profile/' + item.userID)"
            class="ml-9"
          >
            <svg
              height="20px"
              width="20px"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="location-dot"
              class="svg-inline--fa fa-location-dot"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="#B22AF0"
                  d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                ></path>
                <path
                  class="fa-primary"
                  fill="#F8955B"
                  d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                ></path>
              </g>
            </svg>
            From {{ item.created_by }} in {{ item.area }}
          </v-card-subtitle>
        </v-row>
        <br />

        <v-row class="ma-md-3">
          <!-- <v-col class="grid" xs="12" cols="12" sm="12" md="6" lg="4" xl="4">
            <v-date-picker
              v-model="dates"
              elevation="12"
              class="round"
              :min="new Date().toISOString().substr(0, 10)"
              range
            ></v-date-picker>
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-btn
                  color="secondary lighten-1"
                  :elevation="hover ? 24 : 6"
                  width="190"
                  class=" round mx-1 mt-3 font-weight-bold"
                  @click.prevent="clearSelection"
                >
                  Clear Selection
                </v-btn>
              </template>
            </v-hover>
          </v-col> -->

          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-dialog
              v-if="showPicker === true"
              class="round white"
              :key="bookingDates"
              color="primary"
              ref="menu"
              v-model="menu"
              :return-value.sync="dates"
              persistent
              transition="scale-transition"
              offset-y
              width="290"
              rounded
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dates"
                  label="Select date range"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                :allowed-dates="disabledDates"
                elevation="12"
                class="round"
                :min="new Date().toISOString().substr(0, 10)"
                range
                persistent
                no-title
                scrollable
              >
                <!-- <v-spacer></v-spacer> -->
                <v-col class="mt-n3">
                  <v-row>
                    <p
                      v-if="item.minDays > difDays && dates.length > 0"
                      class="text-center red--text white"
                    >
                      The minimum rental period for this item is
                      {{ item.minPeriod }}.
                    </p>
                    <p
                      v-else-if="fullDay && !item.minDate"
                      class="text-center red--text white"
                    >
                      Single day rentals will be billed for 24 hours.
                    </p>
                  </v-row>
                  <div class="text-center mt-4" v-if="dates.length >= 1">
                    <p>{{ dateRange }} day(s) selected</p>
                  </div>

                  <!-- <v-spacer></v-spacer> -->
                  <v-row>
                    <v-btn text color="primary" @click.prevent="clearSelection">
                      Clear
                    </v-btn>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      :disabled="item.minDays > difDays"
                      text
                      color="primary"
                      @click="$refs.menu.save(dates)"
                    >
                      OK
                    </v-btn>
                  </v-row>
                </v-col>
              </v-date-picker>
            </v-dialog>
            <!-- </v-menu> -->
            <p v-if="item.deliveryFee != ''">Do you require delivery?</p>
            <v-switch
              v-if="item.deliveryFee != ''"
              class="black--text"
              color="secondary"
              v-model="deliverySwitch"
              :label="deliverySwitch == true ? 'yes' : 'no'"
            ></v-switch>
            <p v-else class="text-caption red--text">
              Please note this Item does <strong>not</strong> come with delivery
              included.
            </p>
            <span v-if="deliverySwitch == true"
              >Where should the item owner deliver to?</span
            >
            <span v-else-if="deliverySwitch == false"
              >Where will you be using the Item?</span
            >

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  label="Suburb"
                  solo
                  v-model="suburb"
                  class="round mt-2"
                  counter
                  maxlength="25"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      type="text"
                      :description="progress"
                      :color="color"
                      :value="progress"
                      absolute
                      height="7"
                    />
                  </template>
                </v-text-field>
              </template>
              <span>25 characters max</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-textarea
                  v-bind="attrs"
                  v-on="on"
                  class="round"
                  solo
                  v-model="comment"
                  name="input-7-4"
                  onkeypress="return ^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$i.test(event.key)"
                  counter
                  maxlength="250"
                  label="Comments or special requirements"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      type="text"
                      :description="progress"
                      :color="color"
                      :value="progress"
                      absolute
                      height="7"
                    />
                  </template>
                </v-textarea>
              </template>
              <span>150 characters max, no contact numbers or emails.</span>
            </v-tooltip>

            <!-- <p class="text-center red--text">
              Please note bookings are based on a 24 hour cycle to calculate
              number of days booked.
            </p> -->
          </v-col>

          <v-col
            v-if="dates.length >= 1"
            cols="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <v-row class="pa-2" v-if="dates.length >= 1">
              <p
                label="Date range"
                class="black--text font-weight-bold"
                readonly
              >
                {{ dateRange }} days
              </p>
              <v-spacer></v-spacer>
              <p label="Date range" class="black--text font-weight-bold">
                {{ startDateText }} - {{ endDateText }}
              </p>
            </v-row>
            <v-divider class="my-4"></v-divider>
            <v-row class="pa-2">
              <v-menu
                v-model="menu1"
                :nudge-top="80"
                :nudge-left="350"
                transition="scale-transition"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    label="Service Fee text"
                    class="black--text text-body-2 text-decoration-underline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    R{{ item.dailyFee }} x {{ dateRange }} days
                  </p>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="black"
                    class="mb-4 ml-1 text-decoration-none"
                    small
                    >mdi-information</v-icon
                  >
                </template>
                <v-card
                  class="tooltip"
                  style="border-radius: 12px"
                  elevation="12"
                >
                  <v-card-actions
                    ><v-btn @click="menu1 = false" class="mt-n3" icon
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                    <v-card-text
                      class="text-body-2"
                      style="color: rgb(113, 113, 113) !important"
                    >
                      Average daily rate is rounded.
                    </v-card-text></v-card-actions
                  >
                </v-card>
              </v-menu>

              <v-spacer></v-spacer>

              <p
                label="Total Fee"
                class="black--text text-body-2 font-weight-medium"
                prepend="R"
                readonly
              >
                R {{ dailyEffectiveRate }}
              </p>
            </v-row>

            <v-row class="pa-2" v-if="discount != 0">
              <v-menu
                v-if="this.dateRange >= 28"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-top="120"
                :nudge-left="350"
                transition="scale-transition"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    label="Service Fee text"
                    class="black--text text-body-2 text-decoration-underline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>Monthly</span>

                    price discount
                  </p>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="black"
                    class="mb-4 ml-1 text-decoration-none"
                    small
                    >mdi-information</v-icon
                  >
                </template>
                <v-card
                  class="tooltip"
                  style="border-radius: 12px"
                  elevation="12"
                >
                  <v-card-actions
                    ><v-btn @click="menu2 = false" class="mt-n8" icon
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                    <v-card-text
                      class="text-body-2"
                      style="color: rgb(113, 113, 113) !important"
                    >
                      {{ item.created_by }}’s rental has monthly discounts for
                      rentals longer than 7 days.
                    </v-card-text></v-card-actions
                  >
                </v-card>
              </v-menu>

              <v-menu
                v-else
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-top="80"
                :nudge-left="350"
                transition="scale-transition"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    label="Service Fee text"
                    class="black--text text-body-2 text-decoration-underline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>Weekly</span>

                    price discount
                  </p>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="black"
                    class="mb-4 ml-1 text-decoration-none"
                    small
                    >mdi-information</v-icon
                  >
                </template>
                <v-card
                  class="tooltip"
                  style="border-radius: 12px"
                  elevation="12"
                >
                  <v-card-actions
                    ><v-btn @click="menu3 = false" class="mt-n4" icon
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                    <v-card-text
                      class="text-body-2"
                      style="color: rgb(113, 113, 113) !important"
                    >
                      {{ item.created_by }}’s rental has weekly discounts for
                      rentals longer than 7 days.
                    </v-card-text></v-card-actions
                  >
                </v-card>
              </v-menu>

              <v-spacer></v-spacer>

              <p
                label="Total Fee"
                class="green--text text-body-2 font-weight-medium"
                prepend="R"
                readonly
              >
                -R {{ discount }}
              </p>
            </v-row>

            <v-row v-if="deliveryFee != 0" class="pa-2">
              <v-menu
                v-model="menu4"
                :close-on-content-click="false"
                :nudge-top="120"
                :nudge-left="350"
                transition="scale-transition"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    label="Service Fee text"
                    class="black--text text-body-2 text-decoration-underline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    Delivery Fee
                  </p>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="black"
                    class="mb-4 ml-1 text-decoration-none"
                    small
                    >mdi-information</v-icon
                  >
                </template>
                <v-card
                  class="tooltip"
                  style="border-radius: 12px"
                  elevation="12"
                >
                  <v-card-actions
                    ><v-btn @click="menu4 = false" class="mt-n8" icon
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                    <v-card-text
                      class="text-body-2"
                      style="color: rgb(113, 113, 113) !important"
                    >
                      This is the fee for delivery. If it is 0 that means the
                      borrower is expected to collect the item.
                    </v-card-text></v-card-actions
                  >
                </v-card>
              </v-menu>

              <v-spacer></v-spacer>

              <p
                label="Delivery Fee Amount"
                class="black--text text-body-2 font-weight-medium"
                readonly
              >
                R {{ deliveryFee }}
              </p>
            </v-row>

            <v-row class="pa-2">
              <v-menu
                v-model="menu5"
                :close-on-content-click="false"
                :nudge-top="120"
                :nudge-left="350"
                transition="scale-transition"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    label="Service Fee text"
                    class="black--text text-body-2 text-decoration-underline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    Service Fee
                  </p>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="black"
                    class="mb-4 ml-1 text-decoration-none"
                    small
                    >mdi-information</v-icon
                  >
                </template>
                <v-card
                  class="tooltip"
                  style="border-radius: 12px"
                  elevation="12"
                >
                  <v-card-actions
                    ><v-btn @click="menu5 = false" class="mt-n8" icon
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                    <v-card-text
                      class="text-body-2"
                      style="color: rgb(113, 113, 113) !important"
                    >
                      The service fee, which includes a deposit handling fee if
                      applicable , helps us run platform and offer services such
                      as 24/7 support and ensuring the safety of your rentals
                      and transactions.
                    </v-card-text></v-card-actions
                  >
                </v-card>
              </v-menu>

              <v-spacer></v-spacer>

              <p
                label="Service Fee Amount"
                class="black--text text-body-2 font-weight-medium"
                prepend="R"
                readonly
              >
                R {{ totalServiceFee }}
              </p></v-row
            >
            <v-divider class="my-6"></v-divider>

            <v-row class="pa-2">
              <v-menu
                v-model="menu7"
                :close-on-content-click="false"
                :nudge-top="120"
                :nudge-left="350"
                transition="scale-transition"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    label="Service Fee text"
                    class="black--text text-body-2 text-decoration-underline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    Total Rental Fee
                  </p>

                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="black"
                    class="mb-4 ml-1 text-decoration-none"
                    small
                    >mdi-information</v-icon
                  >
                </template>
                <v-card
                  class="tooltip"
                  style="border-radius: 12px"
                  elevation="12"
                >
                  <v-card-actions
                    ><v-btn @click="menu7 = false" class="mt-n8" icon
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                    <v-card-text
                      class="text-body-2"
                      style="color: rgb(113, 113, 113) !important"
                    >
                      The total rental Fee that you pay for the rental period.
                      Not included the deposit that gets refunded to you.
                    </v-card-text></v-card-actions
                  >
                </v-card>
              </v-menu>

              <v-spacer></v-spacer>

              <p
                label="Service Fee Amount"
                class="black--text text-body-2 font-weight-medium"
                prepend="R"
                readonly
              >
                R {{ subTotal }}
              </p></v-row
            >

            <v-divider class="my-6" v-if="item.deposit != ''"></v-divider>

            <v-row class="pa-2" v-if="item.deposit != ''">
              <v-menu
                v-model="menu6"
                :close-on-content-click="false"
                :nudge-top="120"
                :nudge-left="350"
                transition="scale-transition"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    label="Service Fee text"
                    class="black--text text-body-2 text-decoration-underline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    Refundable Deposit
                  </p>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="black"
                    class="mb-4 ml-1 text-decoration-none"
                    small
                    >mdi-information</v-icon
                  >
                </template>
                <v-card
                  class="tooltip"
                  style="border-radius: 12px"
                  elevation="12"
                >
                  <v-card-actions
                    ><v-btn @click="menu6 = false" class="mt-n8" icon
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                    <v-card-text
                      class="text-body-2"
                      style="color: rgb(113, 113, 113) !important"
                    >
                      Refunded after 24 hours upon return, subject to quality
                      check by owner.
                    </v-card-text></v-card-actions
                  >
                </v-card>
              </v-menu>

              <v-spacer></v-spacer>

              <p
                label="Service Fee Amount"
                class="black--text text-body-2 font-weight-medium"
                prepend="R"
                readonly
              >
                R {{ item.deposit }}
              </p></v-row
            >
            <v-divider class="my-6"></v-divider>
            <v-row class="pa-2" style="padding-bottom: 0px !important">
              <p label="Total text" class="black--text" readonly>
                <b>Total </b>
              </p>

              <v-spacer></v-spacer>

              <p label="Grand Total" class="black--text" prepend="R" readonly>
                <b> R {{ total }} </b>
              </p>
            </v-row>
          </v-col>
          <v-col v-else cols="12" sm="12" md="6" lg="6" xl="6">
            <p class="text-h5 text-center">
              Please select pickup and drop off date to continue.
            </p>
            <v-img
              class="mb-0 mt-8 mx-auto"
              contain
              height="290"
              width="300"
              :src="require('@/assets/svgs/calendar-7.svg')"
          /></v-col>
        </v-row>

        <v-row>
          <v-col class="grid">
            <v-btn
              color="secondary lighten-1 "
              width="190"
              class="mx-1 mt-1 font-weight-bold appbutton"
              :class="
                dates.length === 0 || showLoadingForBookItem || !suburb
                  ? ''
                  : 'order'
              "
              rounded
              :disabled="
                dates.length === 0 || showLoadingForBookItem || !suburb
              "
              @click.prevent="submitBooking"
              :loading="showLoadingForBookItem"
            >
              Confirm Availability
            </v-btn>
          </v-col>
          <v-alert
            v-model="bookingAlert"
            border="left"
            close-text="Close Alert"
            dark
            dismissible
          >
            Thank you for submitting your booking request! The lender has been
            notified and will respond to your request shortly.
          </v-alert>
        </v-row>

        <v-alert
          border="bottom"
          colored-border
          type="info"
          color="tan"
          elevation="2"
          class="mt-6 text-caption text-md-body-1"
          v-if="bp"
          @input="onClose"
          dismissible
        >
          All transactions made through Strapp are protected. Once you make the
          payment, we hold your money safely and only release it to the lender
          after youve told us you received the item. Please Note : we can only
          protect you when you use the Strapp payment gateway. Transactions made
          outside of Strapp are not protected.
        </v-alert>
        <v-row class="grid ma-5">
          <v-card style="max-width: 500px" outlined class="pa-2 round">
            <v-row>
              <v-col
                cols="2"
                class="center"
                style="padding: 0px; justify-content: center"
              >
                <!-- <div > -->
                <v-img
                  style="
                    max-height: 50px;
                    max-width: 40px;
                    width: 70%;
                    margin: 15% !important;
                  "
                  :src="require('@/assets/fontawesome/lock-duotone.svg')"
                />
                <!-- </div> -->
              </v-col>

              <v-col class="grid">
                <p style="font-size: 15px; text-align: center; margin: 0px">
                  Get our
                  <b
                    style="
                      color: #b22af0;
                      text-decoration: underline;
                      cursor: pointer;
                    "
                    @click="bp = true"
                  >
                    Borrower Protection</b
                  >
                  when you rent with Strapp!
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-row>
      </v-card>
    </v-dialog>

    <v-overlay v-if="showLoadingForBookItem">
      <v-img :src="require('@/assets/svgs/calendar-4.svg')" />
      Requesting your booking...
    </v-overlay>

    <v-dialog
      v-model="successDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title
            style="
              padding: 0px 24px !important;
              font-size: 1em !important;
              line-height: 1.43;
            "
            class="text-center black--text"
          >
            <p class="my-3 ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text
            style="
              font-size: 16px !important;
              line-height: 20px !important;
              color: rgb(34, 34, 34) !important;
            "
            class="my-2"
          >
            We have recieved your booking request. The lender has been notified
            and we will get back to you shortly!
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="mb-3">
                <v-btn
                  block
                  class="btn white--text"
                  style="border-radius: 8px !important"
                  @click="dashboard()"
                  color="black"
                >
                  Continue to dashboard
                </v-btn>
              </v-row>
              <v-row>
                <v-btn
                  block
                  class="mt-1 btn white--text"
                  style="border-radius: 8px !important"
                  @click="items()"
                  color="accent"
                >
                  Search for another rental
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="signupDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <SignupComponent
        :shouldRedirect="false"
        @loggedIn="signupDialog = false"
        :fromPage="false"
        :addItem="false"
        :addBooking="true"
        @changeDialog="
          signupDialog = false;
          loginDialog = true;
        "
      />
    </v-dialog>

    <v-dialog
      v-model="loginDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <LoginComponent
        :shouldRedirect="false"
        :fromPage="false"
        :addItem="false"
        :addBooking="true"
        @loggedIn="loginDialog = false"
        @changeDialog="
          loginDialog = false;
          signupDialog = true;
        "
      />
    </v-dialog>
  </div>
</template>

<style scoped>
.tooltip {
  background: rgb(255, 255, 255) !important;
  width: 400px !important;
  max-width: 100% !important;
  max-height: 100% !important;
}

.round {
  border-radius: 12px;
}

.white {
  background-color: white;
  margin-bottom: -9px;
  padding-bottom: 7px;
}

.grid {
  display: grid;
  place-items: center;
}

.btn {
  display: inline-block;
  background: #7fc4a1;
  padding: 0.8rem 1.8rem;
  margin-top: 2rem;
  width: 100px;
  cursor: pointer;
  border-radius: 14px;
  font-weight: 700;
  transition: 0.5s;
  color: #a7d1a7;
}
</style>
